/*
 * 无缝滚动弹幕
 */
function requestFrame(cb) {
  return (
    window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    function(callback) {
      window.setTimeout(callback, 1000 / 60)
    }
  )(cb)
}

function scrollLoop() {
  let scrollCon1 = document.getElementById('scrollCon1')
  if (!scrollCon1) return
  scrollCon1.innerHTML += scrollCon1.innerHTML
  function move() {
    let left = scrollCon1.style.left.replace('px', '')
    if (left < -(scrollCon1.offsetWidth / 2)) {
      scrollCon1.style.left = '0'
    }

    scrollCon1.style.left = scrollCon1.offsetLeft - 1 + 'px'
    requestFrame(move)
  }
  requestFrame(move)
}

export { scrollLoop }



// WEBPACK FOOTER //
// ./src/pages/promotion/template/components/scroll.js